
import React, { Component } from "react";

import BsyUserManager from "../BsyUserManager";
import BsyOutsider from '../BsyOutsider'
import BsyCorpCoop from '../BsyCorpCoop'
import BsySysManager from '../BsySysManager'
import { BsyUtils } from '../../utils/Utils';
import BsyAlertInviteUser from "../BsyAlertInviteUser";
import BsyAlert from "../BsyAlert";
import image1 from '../../images/img_kfpt_weihuoqu@2x.png';
import emptyImg from "../../images/img_hulian@2x.png";
import BsyMsgBubble from "../BsyMsgBubble";
import './index.css';
import BsySystemRightMenu from "../BsySystemRightMenu";
import BsySystemLeftMenu from "../BsySystemLeftMenu";
import { setPageTitle } from "../../utils/setPageTitle";

export default class BsyAddressbook extends Component {

  constructor(props) {
    super(props);
    let a = window.location.hash ? window.location.hash.split('#')[1] : (BsyUtils.isOutdiser() && BsyUtils.isSubAdmin() ? 'outsiderManager' : 'userManager');
    a = ['userManager', 'corpCoop', 'outsiderManager', 'systemManager'].indexOf(a) < 0 ? 'userManager' : a;
    this.state = {
      activePane: a,
      haveNews: false,
      is_tmp_owner: false,
      loadSuccess: false,
      dock_corpname: '',
      dock_corpid: '',
      owner_corpid: '',
      owner_corpname: '',
      currentCorpId: '',
      currentCorpName: '',
      openChangeCorp: false,

    }
  }

  componentDidMount() {
    this.initLoad();
    this._getMsgUnread();
  }

  initLoad = () => {
    React.axios("/corp/dock/corp/info").then(res => {
      let id = res.data.owner_coprs.length > 0 ? BsyUtils.getParameterByName("dock_corpid") : "";

      let name = React.language('my.contacts');
      res.data.owner_coprs.map(v => {
        if (v.dock_corpid === id) {
          name = v.dock_corpname
        }
      })
      this.setState({
        loadSuccess: true,
        currentCorpId: id,
        currentCorpName: name,
        is_tmp_owner: res.data.is_tmp_owner,
        has_dock: res.data.has_dock,
        dock_corpname: res.data.dock_corpname,
        dock_corpid: res.data.dock_corpid,
        owner_corpid: res.data.owner_corpid,
        owner_coprs: res.data.owner_coprs,
        owner_corpname: res.data.owner_corpname
      })
    })
  }

  showTabsBody = () => {
    const { activePane, has_dock, currentCorpId, is_tmp_owner } = this.state;
    if (is_tmp_owner && activePane !== "systemManager") {
      return this.showTmpOwner()
    }
    switch (activePane) {
      case 'userManager': {
        setPageTitle( React.language('contacts') + ' - ' + React.language("organization.internal"))
        if (BsyUtils.isOutdiser() && BsyUtils.isSubAdmin()) {
          return <></>
        }
        return <BsyUserManager />
      }
      case 'systemManager': {
        setPageTitle( React.language('contacts') + ' - ' + React.language("manager1"));
        if (!(BsyUtils.isSysManager() || BsyUtils.isCorpOwn()) || !!currentCorpId) {
          return <></>
        }
        return <BsySysManager is_tmp_owner={is_tmp_owner} />
      }
      case 'outsiderManager': {
        setPageTitle(React.language('contacts') + ' - ' + React.language("outsider"))
        return <BsyOutsider currentCorpId={currentCorpId} />
      }
      case 'corpCoop': {
        setPageTitle(React.language('contacts') + ' - ' + React.language("organization.interconnected"))
        if (!(BsyUtils.isSysManager() || BsyUtils.isCorpOwn()) || !!currentCorpId) {
          return <></>
        }
        return has_dock ? <BsyCorpCoop /> : this.notDock()
      }
      default: {
        setPageTitle(React.language('contacts') + ' - ' + React.language("organization.internal"))
        if (BsyUtils.isOutdiser() && BsyUtils.isSubAdmin()) {
          return <></>
        }
        return <BsyUserManager />
      }
    }
  }

  itmeClick = (activePane) => {
    window.location.hash = "#" + activePane;
    this.setState({ activePane: activePane });
  }

  closePane = () => {
    if (this.props.alertDom) {
      this.props.alertDom.props.onRemoveRoot()
    } else {
      if (window.top.location !== window.self.location) {
        window.parent.document.getElementById('addressbook_close').click();
      }
    }
  }

  openNewConnection = () => {
    const { corpCoopList, contactList, contactMap, corpCoopMap } = this.state;
    BsyAlertInviteUser({
      title: React.language('contact.connection.new'),
      styleCss: {
        width: 966,
        height: 620
      },
      type: "corpCoop",
      corpCoopList,
      contactList,
      contactMap,
      corpCoopMap,
      onRefresh: () => {
        // this.RefreshList()
      },
    })
  }

  notDock = () => {
    const tipList = [
      {
        text: React.language("corp.coop.empty.tip1")
      }, {
        text: React.language("corp.coop.empty.tip2")
      }, {
        text: React.language("corp.coop.empty.tip3"),
        // hasBtn: true
      },
    ];
    return (
      <div className="empty-content-tip">
        <div className="empty-box">
          <div className="box-cont">
            <img src={emptyImg} alt="" />
            {
              tipList.map(val => {
                return <div className="setp">
                  <span>{val.text}</span>
                  {val.hasBtn && <a target="_blank" href="#">{React.language('learnMore')}</a>}
                </div>
              })
            }
            <div className="createBtn" onClick={this.openNewConnection}>
              <span>{React.language("contact.connection.new")}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  takeOver = () => {
    BsyAlert({
      title: React.language("contact.take.over.title"),
      msg: React.language("contact.take.over.msg"),
      type: "warning",
      text4Ok: React.language("ok"),
      OkType: "red",
      text4Cancel: React.language("cancel"),
      ok: () => {
        const { dock_corpid, owner_corpid } = this.state;
        React.axios('/corp/transfer_owner', {
          dock_corpid: dock_corpid,
          owner_corpid: owner_corpid,
        }).then(res => {
          // const { target } = this.props;
          // target.parentNode.remove();
          this.initLoad();
        })
      }
    })
  }

  showTmpOwner = () => {
    setPageTitle(React.language('contacts'));
    return (
      <div className="empty-content-tip">
        <div className="empty-box">
          <div className="box-cont">
            <img src={image1} alt="" />
            <div className="setp">
              <span>{React.language('contact.take.over.tip1', { corp: this.state.owner_corpname })}</span>
            </div>
            <div className="setp">
              <span>{React.language('contact.take.over.tip2')}</span>
            </div>
            <div className="createBtn" onClick={this.takeOver}>
              <span>{React.language("contact.take.over")}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  goBack = () => {
    let url = BsyUtils.getParameterByName("referer_uri");
    window.location.href = url ? url : window.location.origin;
  }

  openMessage = (event) => {
    const _this = this;
    new window.FX.Slider({
      title: React.language("message.center"),
      contentWidget: {
        type: "messagecenter",
      },
      onClose: function () {
        _this._getMsgUnread(function (e) {
          if (e.count > 0) {
            _this.setState({ haveNews: true })
          } else {
            _this.setState({ haveNews: false })
          }

        })
      }
    }).show()
  }

  _getMsgUnread = (cb) => {
    let b = this;
    window.FX.Utils.ajax({
      url: "/message/unread",
    },
      function (d) {
        b.setState({
          haveNews: d.count > 0,
          noticeinfo: d.noticeinfo,
        }, () => {
          b.noticeinfo = d.noticeinfo;
          b.createUpDateTip(d);
          cb && cb(d)
        })
      });
  }

  createUpDateTip = (c) => {
    let noticeinfo = c ? c.noticeinfo : this.state.noticeinfo;
    if (BsyUtils.isObjectEmpty(noticeinfo) || window.$(".bsy-update-tip").length > 0) {
      return;
    }
    let updateTip = window.$("<div class='bsy-update-tip' />").css({ "z-index": window.FX.STATIC.zIndex++ }).appendTo(window.$("body"));
    let strKey = "bbynotice_" + noticeinfo.cookie_str;
    window.$("<div class='update-title' />").append(window.$("<span />").text(noticeinfo.title)).append(window.$("<i class='icon icon-bsy-close' />").on("click", function () {
      const closeTime = Math.ceil(new Date().getTime() / 1000);
      const endTime = noticeinfo.endtime - closeTime;
      updateTip.animate({ right: -updateTip.width() + "px" }, 0);
      setTimeout(function () {
        updateTip.remove()
      }, 500);
      endTime > 0 && window.FX.Cookie.set(strKey, closeTime, {
        expires: new Date(noticeinfo.endtime * 1000),
        path: "/"
      });
    })).appendTo(updateTip);
    window.$("<div class='update-cont' />").append(window.$("<span />").text(noticeinfo.content)).appendTo(updateTip);
    window.$("<div class='update-btn' />").append(window.$("<a />").on("click", function () {
      const closeTime = Math.ceil(new Date().getTime() / 1000);
      const endTime = noticeinfo.endtime - closeTime;
      window.FX.Utils.redirectTo(noticeinfo.link, "_blank");
      endTime > 0 && window.FX.Cookie.set(strKey, closeTime, {
        expires: new Date(noticeinfo.endtime * 1000),
        path: "/"
      });
    }).text(React.language("view.detail"))).appendTo(updateTip)
  }

  changeCorp = (event) => {
    const { owner_coprs, currentCorpId } = this.state;
    const _this = this;
    const e = event.currentTarget;
    if (owner_coprs.length === 0) {
      return
    }
    const currteam = React.language("my.contacts");
    this.setState({ openChangeCorp: true }, () => {
      BsyMsgBubble({
        anchor: e,
        contentHTML: () => {
          return (<div className="bby-team-center">
            <div>
              <div>
                <div className="team-title">
                  <i className="icon-bsy-icontongxunlu" />
                  <span>{React.language('my.corp.contacts')}</span>
                </div>
                <div className="split-line"></div>
                <ul className="menu-team">
                  <li className={"menu-item " + (!currentCorpId ? "select" : "")} onClick={this._switch_corp("")} role={""} title={currteam}>
                    <span>{currteam}</span>
                  </li>
                </ul>
              </div>
              <div>
                <div className="team-title">
                  <i className="icon-bsy-owner-corps" />
                  <span>{React.language('escrow.contacts')}</span>
                </div>
                <div className="split-line"></div>
                <div className="teamRoll">
                  <ul className="menu-team">
                    {
                      owner_coprs.map((val) => {
                        return <li className={"menu-item " + (currentCorpId === val.dock_corpid ? "select" : "")} onClick={this._switch_corp(val.dock_corpid)} role={val.dock_corpid} title={val.dock_corpname}>
                          <span>{val.dock_corpname}</span>
                        </li>
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>)
        },
        text4Cancel: null,
        text4Ok: null,
        minWidth: 320,
        width: 320,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        // "marginTop":20,
        onClose: function () {
          _this.setState({ openChangeCorp: false })
          return !1;
        }
      })
    })

  }

  appendParameterToUrl = (url, paramName, paramValue) => {
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;

    if (searchParams.has(paramName)) {
      if (!paramValue) {
        searchParams.delete(paramName);
      } else {
        searchParams.set(paramName, paramValue);
      }
    } else {
      if (paramValue) {
        searchParams.append(paramName, paramValue);
      }
    }

    return urlObj.toString();
  }

  _switch_corp = (dock_corpid) => {
    return () => {
      const url = this.appendParameterToUrl((window.location.href.indexOf("#corpCoop") || window.location.href.indexOf("#systemManager") ? window.location.href.split("#")[0] : window.location.href), 'dock_corpid', dock_corpid);
      window.location.href = url ? url : window.location.origin;
    }
  }

  render() {
    const { activePane, loadSuccess, is_tmp_owner, haveNews, currentCorpName, owner_coprs, currentCorpId, openChangeCorp } = this.state;
    const nickname = window.FX.STATIC.user.nickname;
    const bg = BsyUtils.formatUserThumb(nickname);
    return (loadSuccess && <div className={"addressbook " + window.mode} >
      {
        (BsyUtils.isCorpOwn() || BsyUtils.isSysManager() || BsyUtils.isSubAdmin()) ?
          <>
            <div className="pane-title" >

              {
                <BsySystemLeftMenu
                  homeIcon={() => {
                    return <i className="icon-bsy-left"></i>
                  }}
                  backTitle={React.language('dashboard')}
                  onRenderTitle={() => <div className="left-title"
                    onClick={this.changeCorp}
                  >
                    <span className="currentCorpName">{currentCorpName}</span>
                    {!!currentCorpId && owner_coprs.length > 0 && <span className="currentCorpNameMsg">{" ( " + React.language("escrow") + " ) "}</span>}
                    {owner_coprs.length > 0 && <i className="icon-bsy-xia" style={{ transform: openChangeCorp ? "rotate(180deg)" : "" }}></i>}
                  </div>}
                />
              }

              <div className='tabs' >

                {
                  BsyUtils.isOutdiser() && BsyUtils.isSubAdmin() ? '' :
                    <div className={'item ' + (activePane === 'userManager' ? 'active' : '')} onClick={e => { this.itmeClick('userManager') }} >{React.language("organization.internal")}</div>
                }
                {
                  (!(BsyUtils.isSysManager() || BsyUtils.isCorpOwn()) || !!currentCorpId) ? '' : <div className={'item ' + (activePane === 'corpCoop' ? 'active' : '')} onClick={e => { this.itmeClick('corpCoop') }}  >{React.language("organization.interconnected")}</div>
                }
                <div className={'item ' + (activePane === 'outsiderManager' ? 'active' : '')} onClick={e => { this.itmeClick('outsiderManager') }}  >{React.language("outsider")}</div>
                {
                  (!(BsyUtils.isSysManager() || BsyUtils.isCorpOwn()) || !!currentCorpId) ? '' :
                    <div className={'item ' + (activePane === 'systemManager' ? 'active' : '')} onClick={e => { this.itmeClick('systemManager') }} >{React.language("manager1")}</div>
                }
              </div>
              {/* <i className="addressbook-close icon-close-large" onClick={this.closePane}/> */}
              <div className={'right-menu'}>
                <BsySystemRightMenu />
              </div>
            </div>
            <div className="pane-body">
              {
                this.showTabsBody()
              }
            </div>
          </> : React.language('error.1058')
      }
    </div>
    )
  }
} 
